import { EventValueUpdate } from './EventValueUpdate';

export class EventValueCreate extends EventValueUpdate
{
    id(): string
    {
        return 'Entity.Value.Create';
    }
}
